import options from './sensor-chart.component';

export default {
    selector: 'dtSensorChart',
    options
};
